import { datadogRum } from '@datadog/browser-rum'
import { lifecycle } from 'recompose'

import { ELEMENT_ID } from 'pages/loading'
import { sendEvent } from 'utils/web-view'

// See AFW-2466 for more information
export const withWebviewLifecycle = lifecycle<{}, {}, any>({
  componentDidMount() {
    sendEvent({
      loading: Boolean(document.getElementById(ELEMENT_ID)),
      mounted: true,
    })
  },

  componentDidCatch(error: Error) {
    const { pathname } = this.props.location

    sendEvent({
      error: true,
      message: error.message,
      stack: error.stack,
    })

    datadogRum.addError(
      Error(`Webview "${pathname}" encountered an error: ${error}`),
    )
  },
})
